import React from 'react';

import { Link } from 'libs/router';

import './access-container-footer.scss';

type Props = {
  message: string,
  linkText: string,
  linkTo: string
};

const AccessContainerFooter = ({ message, linkText, linkTo }: Props) => (
  <div className="access-container-footer">
    <span>
      {message}
      {
        linkText && linkTo &&
          <span>
            &nbsp;<Link to={linkTo}>{linkText}</Link>
          </span>
      }
    </span>
  </div>
);

export default AccessContainerFooter;
